export const initialRoundState = {
  // Prompt collection
  promptCollectionPhase: false,
  promptsNeeded: 0,
  promptsPerPlayer: 1,
  submittedPrompts: [],
  promptText: '',
  promptTimeLeft: 0,

  // Active round
  currentPrompt: '',
  responseText: '',
  isWaitingForPrompt: false,
  hasResponded: false,
  currentRound: 0,
  totalRounds: 3,
  countdown: 0,
  responseTimeLeft: 0,

  // Judge
  currentJudgeId: null,
  currentJudgeName: '',
  isJudge: false,
  judgeAward: null,
  hasDrawnAward: false,

  // Voting
  votingPhase: false,
  votingResponses: [],
  hasVoted: false,
  votingResults: [],
  votingTimeLeft: 0,
  gameTopMemes: [],

  // Powerups
  myPowerups: [],
  activePowerupEffects: [],
  powerupSelectPhase: false,
  judgeAnnouncementDuration: 0,
  powerupUsedThisRound: false,
};

export function roundReducer(state, action) {
  switch (action.type) {
    case 'PROMPT_TIMER':
      return { ...state, promptTimeLeft: action.timeLeft };

    case 'PROMPT_TIME_UP':
      return { ...state, promptTimeLeft: 0 };

    case 'PROMPT_SUBMITTED':
      return {
        ...state,
        submittedPrompts: [...state.submittedPrompts, action.prompt],
        promptText: '',
      };

    case 'SET_PROMPT_TEXT':
      return { ...state, promptText: action.promptText };

    case 'RESPONSE_TIMER':
      return { ...state, responseTimeLeft: action.timeLeft };

    case 'RESPONSE_TIME_UP':
      return { ...state, responseTimeLeft: 0 };

    case 'DRAWING_SUBMITTED':
      return {
        ...state,
        responseText: action.data,
        hasResponded: true,
      };

    case 'JUDGE_AWARD_SUBMITTED':
      return { ...state, hasDrawnAward: true };

    case 'VOTING_TIMER':
      return { ...state, votingTimeLeft: action.timeLeft };

    case 'VOTING_TIME_UP':
      return { ...state, votingTimeLeft: 0 };

    case 'VOTE_SUBMITTED':
      return { ...state, hasVoted: true };

    case 'VOTING_COMPLETE':
      return {
        ...state,
        votingResults: action.results,
        judgeAward: action.judgeAward || null,
        votingPhase: false,
      };

    case 'ROUND_COUNTDOWN':
      return { ...state, countdown: action.countdown };

    case 'JUDGE_ANNOUNCED':
      return {
        ...state,
        powerupSelectPhase: true,
        powerupUsedThisRound: false,
        currentJudgeId: action.judgeId,
        currentJudgeName: action.judgeName,
        judgeAnnouncementDuration: action.duration,
      };

    case 'POWERUP_USED':
      return {
        ...state,
        myPowerups: state.myPowerups.filter(p => p.id !== action.powerupId),
        powerupUsedThisRound: true,
      };

    case 'STATE_UPDATE': {
      const d = action.dto;
      return {
        ...state,
        currentRound: d.currentRound,
        totalRounds: d.totalRounds,
        currentJudgeId: d.judgeId || null,
        currentJudgeName: d.judgeName || '',
        isJudge: d.isJudge,
        currentPrompt: d.currentPrompt,
        promptCollectionPhase: d.promptCollectionPhase,
        promptsPerPlayer: d.promptsPerPlayer || 1,
        promptsNeeded: d.promptsNeeded || 0,
        submittedPrompts: d.submittedPrompts || [],
        hasResponded: d.hasResponded,
        hasDrawnAward: d.hasDrawnAward || false,
        votingPhase: d.votingPhase,
        votingResponses: d.votingResponses || [],
        hasVoted: d.hasVoted,
        isWaitingForPrompt: d.gameState === 'playing' && !d.promptCollectionPhase && !d.currentPrompt,
        countdown: 0,
        votingResults: d.currentPrompt ? [] : state.votingResults,
        judgeAward: d.currentPrompt ? null : state.judgeAward,
        myPowerups: d.myPowerups || state.myPowerups,
        activePowerupEffects: d.activePowerupEffects || [],
        // Clear powerup select phase once the prompt/drawing phase begins
        powerupSelectPhase: d.currentPrompt ? false : state.powerupSelectPhase,
      };
    }

    case 'RESET':
      return { ...initialRoundState };

    default:
      return state;
  }
}
